import React from "react"
//import I18n from "i18n-js/index.js.erb"

class CancellationRulePresenterTabs extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <ul className="nav nav-tabs">
          <li role="presentation" className={this.props.active_tab === 'general' ? 'active' : null}>
            <a href="#general" onClick={this.props.onChangeActiveTab.bind(null, 'general')}>
              {I18n.t('general')}
            </a>
          </li>
          <li role="presentation" className={this.props.active_tab === 'billing_policies' ? 'active' : null}>
            <a href="#billing_policies" onClick={this.props.onChangeActiveTab.bind(null, 'billing_policies')}>
              {I18n.t('billing_policies')}
            </a>
          </li>
          <li role="presentation" className={this.props.active_tab === 'taxes' ? 'active' : null}>
            <a href="#taxes" onClick={this.props.onChangeActiveTab.bind(null, 'taxes')}>
              {I18n.t('taxes')}
            </a>
          </li>
        </ul>
      </div>
    )
  }

}

export default CancellationRulePresenterTabs